import { minLength, required } from 'vuelidate/lib/validators'
import phones from '@/assets/validateForms/Phones'
import emails from '@/assets/validateForms/Emails'
import addresses from '@/assets/validateForms/Address'
import contacts from '@/assets/validateForms/Contacts'
import { abnValidator, abnMinLength } from '@/components/validators'
import store from '@/store'

const countryCode = () => {
  const company = store.getters['company/company']
  return company.info ? company.info.countryCode : ''
}

const shouldValidateAbn = () => {
  if (countryCode() === 'AU') {
    return true
  } else {
    return false
  }
}

export default {
  provide: function () {
    return {
      $vv: this.$v
    }
  },
  validations: {
    detailGroup: ['entity.name', 'entity.abn', 'entity.arbn', 'entity.bsb'],
    emailsPhonesGroup: ['entity.emails', 'entity.phones'],
    addressesGroup: ['entity.addresses'],
    contactsGroup: ['entity.contacts'],
    entity: {
      name: {
        required
      },
      abn: {
        minLength: minLength(abnMinLength(countryCode())),
        validAbn: (value) => {
          if (shouldValidateAbn()) {
            return abnValidator(value)
          } else {
            return true
          }
        }
      },
      arbn: {
        minLength: minLength(9)
      },
      bsb: {
        minLength: minLength(6)
      },
      ...addresses,
      ...emails,
      ...phones,
      ...contacts,
      insurerConsumables: {
        $each: {
          value: {
            required
          }
        }
      },
      insurerLoadingValues: {
        $each: {
          value: {
            required
          }
        }
      },
      insurerPaintMaterials: {
        $each: {
          value: {
            required
          }
        }
      },
      insurerSpecialRates: {
        $each: {
          value: {
            required
          }
        }
      }
    }
  }
}
